import axiosInstance from "utils/axios";

export const getPersonalRecormmendationList = async () => {
  return axiosInstance
    .get("chatgpt/getAllAIResponses")
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error);
    });
};

export const getPersonalRecormmendation = async ({ id, tempID, lang }) => {
  return axiosInstance
    .get("chatgpt/getMajorAIResponse", {
      params: {
        major: id,
        lang,
      },
    })
    .then((response) => ({ ...response.data, id: tempID }))
    .catch((error) => {
      throw new Error(error);
    });
};

export const deletePersonalRecormmendation = async (id) => {
  return axiosInstance
    .delete(`chatgpt/deleteAIResponse`, {
      params: {
        id: id,
      },
    })
    .then((response) => ({ ...response.data, id: id }))
    .catch((error) => {
      throw new Error(error);
    });
};
